"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseNavVerticalItemComponent = /** @class */ (function () {
    function FuseNavVerticalItemComponent() {
        this.classes = 'nav-item';
    }
    return FuseNavVerticalItemComponent;
}());
exports.FuseNavVerticalItemComponent = FuseNavVerticalItemComponent;
